module.exports = __webpack_public_path__ + "static/media/Icon.732e7517.svg";